import { BaseIconForFolder } from './tree-type';
import { pathToPath, visiblePath2FullPath } from './device-tree-utils';
import { getIn, remove, setIn } from 'immutable';
import { pathForSetIn } from './path-for-set-in';
import { generateMongoDBId } from 'console/utils/mongo-db';
export function addGroupInTree(path, newTitle, tree_data, device_tree, id) {
    //Заводим новую группу
    const new_group = {
        Name: newTitle,
        Expand: true,
        Children: [],
        id: id ?? generateMongoDBId(),
        Icon: BaseIconForFolder,
    };
    //Проверяем, что корректно ввели
    if (new_group.Name == undefined || new_group.Name === '')
        return device_tree;
    //если в корень добавляем
    if (path.length === 0)
        return setIn(device_tree, [], [...device_tree, new_group]);
    //Находим истинный путь
    const natural_path = visiblePath2FullPath(pathToPath(path[path.length - 1], tree_data), device_tree);
    const children = getIn(device_tree, pathForSetIn(natural_path).with_children, []);
    //Вернём дерево с измененным значением
    return setIn(device_tree, pathForSetIn(natural_path).with_children, [
        ...children,
        new_group,
    ]);
}
export function addDeviceInGroup(data, device_id) {
    //Находим истинный путь
    const natural_path_of_parent = visiblePath2FullPath(pathToPath(data.parentPath[data.parentPath.length - 1], data.treeData), data.device_tree);
    if (natural_path_of_parent[0] === -1) {
        return setIn(data.device_tree, [], [...data.device_tree, { ZontId: device_id }]);
    }
    const children = getIn(data.device_tree, pathForSetIn(natural_path_of_parent).with_children, []);
    //Вернём дерево с измененным значением
    return setIn(data.device_tree, pathForSetIn(natural_path_of_parent).with_children, [
        ...children,
        { ZontId: device_id },
    ]);
}
export function changeGroupName(path, newTitle, tree_data, device_tree) {
    //Находим настоящий путь до группы, которую хотим переименовать
    const natural_path_of_rename_group = visiblePath2FullPath(pathToPath(path[path.length - 1], tree_data), device_tree);
    //Находим эту группу
    const rename_node = getIn(device_tree, pathForSetIn(natural_path_of_rename_group).without_children, []);
    //Если ничего не ввели, или ввели тоже самое, то вернем исходное дерево
    if (newTitle == undefined || newTitle === rename_node.Name)
        return device_tree;
    //Вернём дерево с измененным значением
    return setIn(device_tree, pathForSetIn(natural_path_of_rename_group).without_children, setIn(rename_node, ['Name'], newTitle));
}
export function removeGroupFromTree(path, tree_data, device_tree) {
    //Найдём индекс группы, которую хотим удалить
    const natural_path_remove_group = visiblePath2FullPath(pathToPath(path[path.length - 1], tree_data), device_tree);
    const index_of_remove_group = natural_path_remove_group.slice(-1)[0];
    //Возьмём детей из группы, которую хотим удалить
    const children_from_group = getIn(device_tree, pathForSetIn(natural_path_remove_group).with_children, []);
    //Найдём путь, по которому будем вставлять новые элементы
    const path_for_add_items = pathForSetIn(natural_path_remove_group).without_children.slice(0, -1);
    //Найдём всех детей, которые были по тому пути
    const children_from_path = getIn(device_tree, path_for_add_items, []);
    //Удалим группу оттуда
    const children_from_path_without_group = remove(children_from_path, index_of_remove_group);
    //Вернём дерево с измененным значением, вставляя детей на место удалённой группы
    return setIn(device_tree, path_for_add_items, [
        ...children_from_path_without_group.slice(0, index_of_remove_group),
        ...children_from_group,
        ...children_from_path_without_group.slice(index_of_remove_group),
    ]);
}
